module.exports = __webpack_public_path__ + "static/media/paul.fd5c385a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/peopleCompany/paul.png
// module id = 747
// module chunks = 0